export default __webpack_public_path__ + "static/media/globe.fcdcd4e8.png";